import React from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import ViewDetails from '../../modules/subject/components/ViewDetails';

const ViewDetailsPage = ({ isGroup = false }: { isGroup?: boolean }) => {
  const { t } = useTranslation();
  const title = t('amendment->>SubjectAmendment.View Registration');

  return (
    <>
      <TitleHeader title={title} />
      <ViewDetails isGroup={isGroup} />
    </>
  );
};

export default ViewDetailsPage;
